// extracted by mini-css-extract-plugin
export default {"label":"OszWXAZQk15IAp3WSaOl"};